const SectionHeading = ({ eyebrow, title, children, className = "" }) => {
  return (
    <div className={`flex max-w-3xl flex-col gap-4 ${className}`}>
      {eyebrow && <p className="eyebrow">{eyebrow}</p>}
      <h2 className="heading">{title}</h2>
      {children && <div className="lead flex flex-col gap-4">{children}</div>}
    </div>
  );
};

export default SectionHeading;
